import { LoginForm } from 'features/authentication'

export const LoginPage = () => (
  <LoginForm />
)
